import { FormControl, Grid, InputAdornment, TextField, Typography } from '@material-ui/core'
import { useForm } from 'hooks/useForm'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { EndowmentsSubmit } from './EndowmentsSubmit'
import { useSelector } from 'react-redux'
// "rotogauge": 89.5,
//     "flowmeter": 0
const MAX_CILINDERS = 30
export const FormEndowment = ({onClose, data}) => {
  const {endowment} = useSelector(state => state.routesStatus)
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({
    cil10: 0,
    cil20: 0,
    cil30: 0,
    cil45: 0,
    rotogauge: 0,
    capacity: 0,
    flowmeter: 0,
    total: 0
    })

    const {
      cil10, cil20, cil30, cil45, rotogauge, capacity, flowmeter, total 
    } = inputValues

    useEffect(() => {
      if(data.type === "PORTATIL") {
        handleNewValues({
          cil10: data.cil10,
          cil20: data.cil20,
          cil30: data.cil30,
          cil45: data.cil45,
          total: data.cil10 + data.cil20 + data.cil30 + data.cil45,
        })
      } else {
        handleNewValues({
          rotogauge: data.rotogauge,
          capacity: data.capacity,
          flowmeter: data.flowmeter,
          total: data?.capacity,
        })
      }
    }, [data, endowment])


  useEffect(() => {
    handleNewValues({
      total: parseInt(cil10) + parseInt(cil20) + parseInt(cil30) + parseInt(cil45)
    })
  }, [cil10, cil20, cil30, cil45])

  useEffect(() => {
    handleNewValues({
      total: rotogauge
    })
  }, [rotogauge])

  return (
    <FormControl fullWidth >
      <Grid container spacing={1}>
        {
          data.type === "PORTATIL"
            ?
          <>
          <Grid item xs={3}>
          <TextField
            variant='outlined'
            label="10kg"
            name="cil10"
            value={cil10}
            onChange={handleInputOnChange}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            variant='outlined'
            label="20kg"
            name="cil20"
            value={cil20}
            onChange={handleInputOnChange}
            type="number"
            inputProps={{min: 0}}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            variant='outlined'
            label="30kg"
            name="cil30"
            value={cil30}
            onChange={handleInputOnChange}
            type="number"
            inputProps={{min: 0}}
            fullWidth
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            variant='outlined'
            label="45kg"
            name="cil45"
            value={cil45}
            onChange={handleInputOnChange}
            type="number"
            inputProps={{min: 0}}
            fullWidth
          />
        </Grid>
          </>
          :
          <>
          <Grid item xs={6} fullWidth>
              <TextField
                fullWidth
                variant='outlined'
                label="Rotogauge"
                name="rotogauge"
                value={rotogauge}
                onChange={handleInputOnChange}
                type="number"
                inputProps={{min: 0, max: 99}}
                align="center"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      %
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          <Grid item xs={6} fullWidth>
              <TextField
                fullWidth
                variant='outlined'
                label="Medidor"
                name="flowmeter"
                value={flowmeter}
                onChange={handleInputOnChange}
                type="number"
                inputProps={{min: 0,}}
                align="center"
                disabled
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      lts
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            </>
        }
        {
          data.type === 'PORTATIL'
          ?
            <Grid item xs={12} >
              <Typography component="p" align="right" color={ total > MAX_CILINDERS ? 'secondary' : 'primary' }>
                Cilindros:  { total } / { MAX_CILINDERS }
              </Typography>
            </Grid>
          :
            <Grid item xs={12} >
              <Typography component="p" align="right" >
                Capacidad Maxima: { capacity }
              </Typography>
            </Grid>
        }
        {
          total > 30 && data.type === 'PORTATIL' &&
          <Grid item xs={12}>
            <Typography component="p" variant="caption" align="right" color="secondary">
              Solo se permiten un maximo de { MAX_CILINDERS } cilindros por unidad.
            </Typography>
          </Grid>
        }
      </Grid>
      <EndowmentsSubmit onClose={onClose} total={total} form={inputValues} data={data}/>
    </FormControl>
  )
}









